// extracted by mini-css-extract-plugin
export default {"centered":"AppLoading_centered__ih30O"};